import React, { useState } from 'react';
import './PriceCompare.scss';
import { useSelector } from 'react-redux';
import RecentSearch from './recent-search/RecentSearch';
import '../PriceCompare/components/ProcedureProviderContainer.scss';
import PriceCompareSearch from './PriceCompareSearch';
const PriceCompare = () => {
  const { searchParamsForUI, searchProviderParams } = useSelector(
    (state) => state.priceCompareAdmin,
  );

  const [procedureForData, setProcedureForData] = useState(
    searchParamsForUI?.procedureForData
      ? searchParamsForUI?.procedureForData
      : null,
  );

  const [procedureForDataParent, setProcedureForDataParent] = useState(
    searchParamsForUI?.procedureForData
      ? searchParamsForUI?.procedureForData
      : null,
  );

  const setParentUserData = (data) => {
    setProcedureForDataParent(data);
  };

  return (
    <div className="price-comparison-admin-container container-fluid">
      <div className="px-0">
        <PriceCompareSearch
          label="search"
          setProcedureForDataParent={setParentUserData}
        />
        {procedureForDataParent && (
          <div className="recent-search-container mt-4">
            {
              <RecentSearch
                showingResultItem={5}
                member={procedureForDataParent}
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};
export default PriceCompare;
